import * as React from 'react';
import styled, { css } from 'styled-components';

export interface IconProps {
  className?: string;
  iconType: string;
  iconSize?: string;
  customIconSize?: number;
  invertedTheme?: boolean;
  viewBox?: string;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

const bigIconSize = '32';
const smallIconSize = '24';

const getIconSize = (iconSize?: string) => {
  if (iconSize === 'big') {
    return bigIconSize;
  }

  return smallIconSize;
};

const getPath = (iconType: string) => {
  switch (iconType) {
    case 'check':
      return (
        <polyline
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="8,12.14 10.91,15 16,10"
        />
      );
    case 'arrow-down':
      return (
        <polyline
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="8,10 12,14 16,10"
        />
      );
    case 'arrow-up':
      return (
        <polyline
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="8,10 12,14 16,10"
        />
      );
    case 'arrow-right':
      return (
        <polyline
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="8,10 12,14 16,10"
        />
      );
    case 'arrow-left':
      return (
        <polyline
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="8,10 12,14 16,10"
        />
      );
    case 'amazon':
      return (
        <Path d="M16.3 15.7c-0.1 0-0.1 0-0.2 0 -0.1 0-0.1 0.1-0.2 0.1l-0.1 0 -0.1 0.1v0c-1.3 0.5-2.6 0.8-3.9 0.9 0 0-0.1 0-0.1 0 -2 0-3.6-0.9-5.2-1.8 0 0-0.1 0-0.2 0 -0.1 0-0.1 0-0.2 0.1C6 15.1 6 15.1 6 15.2c0 0.1 0.1 0.2 0.1 0.3C7.7 16.8 9.3 18 11.6 18c0 0 0.1 0 0.1 0 1.4 0 3-0.5 4.3-1.3l0 0c0.2-0.1 0.3-0.2 0.5-0.3 0.1-0.1 0.2-0.2 0.2-0.3C16.6 15.9 16.5 15.7 16.3 15.7zM18 15L18 15c0-0.1 0-0.2-0.1-0.3l0 0 0 0c0-0.1-0.1-0.1-0.2-0.1 -0.2-0.1-0.4-0.1-0.7-0.1 -0.2 0-0.4 0-0.7 0.1l0 0 -0.2 0.1 0 0 -0.1 0v0c-0.1 0.1-0.3 0.1-0.4 0.2 -0.1 0.1-0.1 0.1-0.1 0.3 0 0.1 0 0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.2 0.1 0 0 0 0 0 0l0 0 0 0c0.1 0 0.3 0 0.5-0.1 0.2 0 0.3 0 0.5 0 0.1 0 0.2 0 0.3 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0.4-0.1 0.6 -0.1 0.2-0.2 0.5-0.2 0.6 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.2 0.1h0c0.1 0 0.2 0 0.2-0.1 0.6-0.5 0.8-1.4 0.8-1.8L18 15zM12.4 12.5c-0.2 0.4-0.5 0.6-0.8 0.7 0 0-0.1 0-0.2 0 -0.6 0-0.9-0.4-0.9-1.1 0-0.8 0.5-1.2 1.1-1.4 0.3-0.1 0.7-0.1 1.1-0.1v0.3C12.6 11.5 12.7 12 12.4 12.5zM12.6 9.3c-0.3 0-0.7 0.1-1.1 0.1 -0.6 0.1-1.2 0.2-1.7 0.4 -1 0.4-1.6 1.3-1.6 2.5 0 1.6 1 2.4 2.3 2.4 0.4 0 0.8 0 1.1-0.1 0.5-0.2 0.9-0.4 1.4-1 0.3 0.4 0.4 0.6 0.9 1 0.1 0.1 0.3 0.1 0.4 0 0.3-0.3 0.9-0.7 1.2-1 0.1-0.1 0.1-0.3 0-0.4 -0.3-0.4-0.6-0.7-0.6-1.4V9.4c0-1 0.1-1.9-0.7-2.6C13.5 6.2 12.6 6 11.8 6H11.5c-1.3 0.1-2.8 0.7-3.1 2.3C8.4 8.5 8.5 8.6 8.6 8.7l1.5 0.2c0.2 0 0.2-0.2 0.3-0.3 0.1-0.6 0.6-0.9 1.1-0.9h0.1c0.3 0 0.7 0.1 0.9 0.4 0.2 0.3 0.2 0.7 0.2 1.1L12.6 9.3 12.6 9.3z" />
      );
    case 'google':
      return (
        <Path d="M10.2 6.2l6.5 3.7 -1.8 1.8 -5.8-5.6C9.2 6.1 9.3 6 9.5 6 9.7 6 10 6.1 10.2 6.2zM8 16.6V7.4C8 7 8.2 6.6 8.6 6.3l5.9 5.7 -5.8 5.7C8.2 17.4 8 17 8 16.6zM10.2 17.8c-0.3 0.2-0.7 0.2-1.1 0.2l5.7-5.5 1.8 1.7C16.7 14.2 10.2 17.8 10.2 17.8zM18.3 13.2l-1.2 0.7 -1.9-1.8 2-1.9 1.1 0.7c0.5 0.3 0.7 0.7 0.7 1.3C19.1 12.5 18.8 13 18.3 13.2z" />
      );
    case 'apple':
      return (
        <Path d="M16.8 15.4c-0.2 0.4-0.4 0.8-0.6 1.2 -0.3 0.5-0.6 0.8-0.8 1 -0.3 0.3-0.7 0.5-1.1 0.5 -0.3 0-0.6-0.1-1-0.2 -0.4-0.2-0.7-0.2-1-0.2 -0.3 0-0.7 0.1-1.1 0.2 -0.4 0.2-0.7 0.2-0.9 0.3 -0.4 0-0.7-0.1-1.1-0.5 -0.2-0.2-0.5-0.5-0.9-1 -0.4-0.5-0.7-1.1-0.9-1.8C7.1 13.9 7 13.2 7 12.5c0-0.8 0.2-1.5 0.5-2.1C7.8 9.9 8.2 9.6 8.6 9.3c0.5-0.3 0.9-0.4 1.5-0.4 0.3 0 0.7 0.1 1.1 0.3 0.5 0.2 0.8 0.3 0.9 0.3 0.1 0 0.4-0.1 1-0.3 0.5-0.2 1-0.3 1.4-0.2 1 0.1 1.8 0.5 2.3 1.2 -0.9 0.6-1.3 1.3-1.3 2.3 0 0.8 0.3 1.4 0.8 1.9 0.2 0.2 0.5 0.4 0.8 0.6C16.9 15 16.9 15.2 16.8 15.4L16.8 15.4zM14.5 6.2c0 0.6-0.2 1.2-0.6 1.7 -0.5 0.6-1.1 1-1.8 0.9C12 8.8 12 8.7 12 8.6c0-0.6 0.3-1.2 0.7-1.7 0.2-0.3 0.5-0.5 0.8-0.6 0.3-0.2 0.7-0.3 1-0.3C14.5 6.1 14.5 6.2 14.5 6.2L14.5 6.2z" />
      );
    case 'menu':
      return (
        <>
          <line
            fill="none"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="10"
            y1="12"
            x2="22"
            y2="12"
          />
          ,
          <line
            fill="none"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="10"
            y1="16"
            x2="22"
            y2="16"
          />
          ,
          <line
            fill="none"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="10"
            y1="20"
            x2="22"
            y2="20"
          />
        </>
      );
    case 'close':
      return (
        <path d="M15.2 8.8c0.2 0.2 0.2 0.6 0 0.8L12.8 12l2.4 2.4c0.2 0.2 0.2 0.6 0 0.8 -0.2 0.2-0.6 0.2-0.8 0L12 12.8l-2.4 2.4c-0.2 0.2-0.6 0.2-0.8 0 -0.2-0.2-0.2-0.6 0-0.8L11.2 12 8.8 9.6c-0.2-0.2-0.2-0.6 0-0.8 0.2-0.2 0.6-0.2 0.8 0L12 11.2l2.4-2.4C14.6 8.6 15 8.6 15.2 8.8z" />
      );
    case 'handle':
      return (
        <>
          <line
            fill="none"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="7"
            y1="12"
            x2="17"
            y2="12"
          />
          <line
            fill="none"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="7"
            y1="15"
            x2="17"
            y2="15"
          />
          <line
            fill="none"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="7"
            y1="9"
            x2="17"
            y2="9"
          />
        </>
      );
    default:
      return <path />;
  }
};

export const Icon: React.FC<IconProps> = (props) => (
  <svg
    onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
    width={getIconSize(props.iconSize)}
    height={getIconSize(props.iconSize)}
    viewBox="0 0 24 24"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <circle className="circle" cx="12" cy="12" r="12" />
    <g className="icon">{getPath(props.iconType)}</g>
  </svg>
);

export default styled(Icon)`
  ${(props) =>
    props.customIconSize
      ? css`
          width: ${props.customIconSize}px;
          height: ${props.customIconSize}px;
        `
      : null}

  ${(props) =>
    props.customIconSize && props.customIconSize > 32
      ? css`
          .icon {
            transform: scale(0.75);
            transform-origin: center;
          }
        `
      : null}

  .circle {
    transition: fill
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
    opacity: ${(props) =>
      props.iconType === 'back' || props.iconType === '' ? '.2' : '1'};

    fill: ${(props) =>
      props.invertedTheme
        ? css`
            ${({ theme }) => theme.colors.midGray};
          `
        : css`
            ${({ theme }) => theme.colors.inputBackgroundAlternate}
          `};

    ${(props) =>
      props.iconType === 'check'
        ? css`
            fill: ${({ theme }) => theme.colors.success};

            polyline {
              strike: ${({ theme }) => theme.colors.successText};
            }
          `
        : null}
    ${(props) =>
      props.iconType === 'amazon' ||
      props.iconType === 'google' ||
      props.iconType === 'apple'
        ? css`
            fill: ${({ theme }) => theme.colors.primary};
          `
        : null};
  }

  ${(props) =>
    props.iconType === 'arrow-up' ||
    props.iconType === 'arrow-down' ||
    props.iconType === 'arrow-left' ||
    props.iconType === 'arrow-right'
      ? css`
          polyline {
            stroke: ${({ theme }) => theme.colors.primary};
          }
        `
      : null}

  ${(props) =>
    props.onClick
      ? css`
          cursor: pointer;

          .circle {
            transition: opacity
                ${({ theme }) =>
                  `${theme.transitions.duration} ${theme.transitions.type}`},
              fill
                ${({ theme }) =>
                  `${theme.transitions.duration} ${theme.transitions.type}`};
          }

          &:hover {
            .circle {
              opacity: 0.5;
            }
          }
        `
      : null}

  .icon {
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
    opacity: ${(props) => (props.iconType === '' ? '0' : '1')};
  }

  polyline {
    transform: rotate(0);
    transform-origin: center center;
    transition: transform
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  ${(props) =>
    props.iconType === 'handle' || props.iconType === 'menu'
      ? css`
          cursor: grab;
          .circle {
            fill: ${({ theme }) => theme.colors.iconBackground};
          }
          .icon {
            & > line {
              stroke: ${({ theme }) => theme.colors.primary};
            }
          }
        `
      : null};

  ${(props) =>
    props.iconType === 'close'
      ? css`
          .icon {
            & > path {
              fill: ${({ theme }) => theme.colors.primary};
            }
          }
        `
      : null};

  ${(props) =>
    props.iconType === 'arrow-up'
      ? `
    polyline {
      transform: rotate(180deg);
    }
  `
      : null};

  ${(props) =>
    props.iconType === 'arrow-right'
      ? css`
          polyline {
            transform: rotate(-90deg);
            stroke: ${({ theme }) => theme.colors.primary};
          }
        `
      : null};

  ${(props) =>
    props.iconType === 'arrow-left'
      ? css`
          polyline {
            transform: rotate(90deg);
            stroke: ${({ theme }) => theme.colors.primary};
          }
        `
      : null};
`;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.background};
`;
